import JackpotItem from './JackpotItem';
export default JackpotItem;